export { default } from './UploadVisualsView';



// WEBPACK FOOTER //
// ./src/components/views/UploadVisualsView/index.js